<template>
  <div class="card">
    <div v-if="$slots.actions" class="actions">
      <slot name="actions"/>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '~style/variables';

.card {
  background: #fff;
  border-radius: $r;
  border: 1px solid $c-grey;
  margin-bottom: 1rem;
  position: relative;

  > .actions {
    position: absolute;
    right: 0.25rem;
    top: 0.125rem;
    > .ic {
      color: $c-text-light;
    }
  }

  .rw {
    // height: $lh;
    line-height: $lh;
  }

  > .simple-row {
    padding: 1rem;
  }

  > .flex-row {
    > .left {
      max-width: 65%;
      padding: 1rem;
    }
    > .right {
      align-items: center;
      display: flex;
      margin-left: auto;
      // padding: 1rem;
      &.border {
        border-left: 1px solid $c-border-light;
      }
    }
    > .center {
      margin: 0 auto;
      padding: 1rem;
    }
  }

  > .simple-row, > .flex-row {
    &.border-top {
      border-top: 1px solid $c-border-light;
    }
    &.no-pad {
      padding: 0;
    }
  }

  > .flex-row {
    display: flex;
  }

  > .footer {
    padding-top: 0.5rem;
  }

  strong {
    @include ellipsis;
    color: $c-text-black;
    display: block;
    font-weight: $semibold;
    &.gray {
      color: $c-text-lightish;
    }
  }

  > .meta {
    background: $c-light;
    border-top: 1px solid $c-border-light;
    color: $c-text-lightish;
    font-size: $h6;
    // padding: 0.5rem 1rem;
    .right {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Card.vue